import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { minWidth } from '../../helpers/media-queries';

const styles = () => ({
    root: {
        paddingBottom: '25px',
        [minWidth.xl]: {
            margin: '5px 0',
            width: '40px',
            position: 'absolute',
            bottom: '-93vh',
            height: '120px',
            right: '-50px',
            paddingBottom: '0',
        }
    },
    btn: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontFamily: "'zx_spectrum7_boldregular', sans",
        '&:active': {
            transform: 'translateY(5%)',
        },
        '&:active, &:focus, &:visited': {
            border: 'none',
        },
        [minWidth.xl]: {
            marginBottom: '10px',
        }
    }
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    share: (social) => stores.social.shareWebsite(social),
})

class SocialButtons extends Component {
    render() {
        const { classes, share, intl } = this.props;
        return (
            <div className={classes.root}>
                <button
                    type="button"
                    arial-label={intl['LOCALE.SHARE.WHATSAPP']}
                    className={classes.btn}
                    onClick={() => share('whatsapp')}>
                    <img 
                        src="./static/images/social-whatsapp.png" 
                        alt={intl['LOCALE.SHARE.WHATSAPP']} 
                        title={intl['LOCALE.SHARE.WHATSAPP']}  />
                </button>
                <button
                    type="button"
                    arial-label={intl['LOCALE.SHARE.FACEBOOK']}
                    className={classNames("fb-like", classes.btn)}
                    onClick={() => share('facebook')}
                    data-share="true"
                    data-width="450"
                    data-show-faces="true">
                    <img 
                        src="./static/images/social-facebook.png" 
                        alt={intl['LOCALE.SHARE.FACEBOOK']} 
                        title={intl['LOCALE.SHARE.FACEBOOK']}  />
                </button>
                <button
                    type="button"
                    arial-label={intl['LOCALE.SHARE.TWITTER']}
                    className={classes.btn}
                    onClick={() => share('twitter')}>
                    <img 
                        src="./static/images/social-twitter.png" 
                        alt={intl['LOCALE.SHARE.TWITTER']} 
                        title={intl['LOCALE.SHARE.TWITTER']}  />
                </button>
            </div>

        )
    }
}

export default inject(mapper)(
    withStyles(styles)(SocialButtons)
);